module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/Twitter.7a2f4916.svg";